import React from 'react';
import '../../../styles/traditionalprocessfaq.scss';

export default function Traditionalprocessfaq(props) {
	return (
		<div>
			{
				props?.partner?.url_path === 'megastar' ?
					<div>
						<div className="pl-3">
							The 7-Day Non-Contingent Buyer Program is more convenient, less stressful, and often cheaper than the traditional process. Using the program, you will be able to:
						</div>
						<br />
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li><b>Win with non-contingent offers that function like all-cash offers.</b>&nbsp;Importantly, many real estate agents are able to leverage non-contingent offers to negotiate a lower purchase price.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Buy and move into your new home before you sell your original one.</b>&nbsp;This allows you to avoid the stress of trying to time the sale of your original home with the purchase of your new home, submitting contingent offers, or moving into a short-term rental while you look for a new home.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Prep your original home for sale after you have moved out.</b>&nbsp;This allows you to avoid the hassle of constantly cleaning and organizing your home to maintain show-readiness while you are living in it. Furthermore, many clients choose to take advantage of the vacancy to make repairs and stage their original home so that it sells for maximum value.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Experience peace of mind with a guaranteed backup offer.</b>&nbsp;We’ve got your back if the market shifts. You don’t have to worry that you’ll be carrying two mortgages indefinitely or your home will remain unsold for months on end.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Likely experience cost savings.</b>&nbsp;For a small fee, you will move forward with a conventional loan on your new home without incurring the costs of moving twice, short-term rentals, and/or private mortgage insurance.
								</li>
							</ul>
						</div>
					</div>
					:
					<div>
						<div className="pl-3">
							{props?.partner?.url_path === 'c2'?"C2 Buy Before You Sell":"The Trade-In Mortgage™"} is more convenient, less stressful, and often cheaper than the traditional process. Using {props?.partner?.url_path === 'c2'?"C2 Buy Before You Sell":"The Trade-In Mortgage™"}, you will be able to:
						</div>
						<br />
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li><b>Win with non-contingent offers that function like all-cash offers.</b>&nbsp;Submit non-contingent offers on new home prospects, positioning you as a competitive buyer in today’s increasingly crowded real estate market. Importantly, many real estate agents are able to leverage non-contingent offers to negotiate a lower purchase price.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Buy and move into your new home before you sell your original one.</b>&nbsp;This allows you to avoid the stress of trying to time the sale of your original home with the purchase of your new home, submitting contingent offers, or moving into a short-term rental while you look for a new home.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Prep your original home for sale after you have moved out.</b>&nbsp;This allows you to avoid the hassle of constantly cleaning and organizing your home to maintain show-readiness while you are living in it. Furthermore, many clients choose to take advantage of the vacancy to make repairs and stage their original home so that it sells for maximum value.
								</li>
							</ul>
						</div>
						<div className="how-content-traditionalprocessfaq">
							<ul className="pl-3">
								<li>
									<b>Likely experience cost savings.</b>&nbsp;For a small fee, you will move forward with a conventional loan on your new home without incurring the costs of moving twice, short-term rentals, and/or private mortgage insurance.
								</li>
							</ul>
						</div>
					</div>
			}
		</div>
	)
}